export default "__VITE_ASSET__CWifqrcy__"